import type { SegmentCondition, SegmentDefinition } from '@aimmo/contracts';

/**
 * The body of a segment preview, from the conditions as the builder last
 * settled them (serialized, so the debounced value compares by content).
 *
 * `null` while there is nothing to ask: the debounced value can still be the
 * empty list for a moment after the first condition is added, and an empty
 * definition is refused by the API anyway.
 */
export function segmentPreviewBody(settled: string): { definition: SegmentDefinition } | null {
  const conditions = JSON.parse(settled) as SegmentCondition[];
  if (conditions.length === 0) return null;
  return { definition: { conditions } };
}
